import { render, staticRenderFns } from "./addRegulation.vue?vue&type=template&id=3640c6d9"
import script from "./addRegulation.vue?vue&type=script&lang=js"
export * from "./addRegulation.vue?vue&type=script&lang=js"
import style0 from "./addRegulation.vue?vue&type=style&index=0&id=3640c6d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports